import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, message, Tooltip } from "antd";
import { OrderedListOutlined, FileExcelOutlined } from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockMovementHistoryFilter from "../Filters/StockMovementHistoryFilter";
import config from "util/ApiforContext";

const StockMovementHistoryReport = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "STOK HAREKETLERİ RAPORU",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");

  useEffect(
    () => getTableData(),
    [props?.match?.params?.stockId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    setQuery(query + order);

    RequestHandler.get(
      `/StockMovement?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.substring(0, 20).length < 20
                ? text.substring(0, 20) + ""
                : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.substring(0, 20).length < 20
                ? text.substring(0, 20) + ""
                : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Hareket Tarihi",
      dataIndex: "addDateString",
      key: "addDateString",
      align: "left",
    },
    {
      title: "Hareket Tipi",
      dataIndex: "stockMovementTypeName",
      key: "stockMovementTypeName",
      align: "left",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";
        else
          return (
            <Tooltip title={text}>
              <span>
                {text.substring(0, 20).length < 20
                  ? text.substring(0, 20) + ""
                  : text.substring(0, 20) + "..."}
              </span>
            </Tooltip>
          );
      },
    },
    {
      title: "Proje",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
    },

    {
      title: "Giren Stok",
      dataIndex: "addStockCount",
      key: "addStockCount",
      align: "left",
      render: (text) => (
        <div style={{ color: "green" }}>
          {renderDecimal(text) == "0,00" ? "" : renderDecimal(text)}
        </div>
      ),
    },
    {
      title: "Çıkan Stok",
      dataIndex: "stockOutCount",
      key: "stockOutCount",
      align: "left",
      render: (text) => (
        <div style={{ color: "red" }}>
          {renderDecimal(text) == "0,00" ? "" : renderDecimal(text)}
        </div>
      ),
    },
    {
      title: "Güncel Stok",
      dataIndex: "stockBalanceTotal",
      key: "stockBalanceTotal",
      align: "center",
      render: renderDecimal,
    },
    {
      title: "Stok Birimi",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "Birim Fiyat",
      dataIndex: "amountString",
      key: "amountString",
      align: "left",
    },
    {
      title: "Toplam Fiyat",
      dataIndex: "totalAmountString",
      key: "totalAmountString",
      align: "left",
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      "/StockMovement/ExportReportExcel",
      {
        query: query,
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/StockMovement/DownloadReportExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "end" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <StockMovementHistoryFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={true}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockMovementHistoryReport;
